var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9992 1.19995C6.04413 1.19995 1.19922 6.04486 1.19922 12C1.19922 16.6412 4.14226 20.6072 8.25978 22.1317C8.14118 21.0745 8.15978 19.343 8.35547 18.5046C8.53873 17.7172 9.53936 13.4863 9.53936 13.4863C9.53936 13.4863 9.23728 12.8814 9.23728 11.9879C9.23728 10.5838 10.0508 9.53622 11.0638 9.53622C11.9254 9.53622 12.3409 10.1831 12.3409 10.9582C12.3409 11.8248 11.7899 13.1194 11.5045 14.3192C11.2665 15.3245 12.0085 16.1442 12.9995 16.1442C14.7938 16.1442 16.173 14.2521 16.173 11.5212C16.173 9.10406 14.4365 7.41381 11.9565 7.41381C9.0843 7.41381 7.39832 9.56844 7.39832 11.7953C7.39832 12.6628 7.73226 13.5931 8.14967 14.0995C8.23198 14.1996 8.24401 14.287 8.21957 14.3887C8.14307 14.7075 7.97301 15.3933 7.93922 15.5338C7.89534 15.719 7.79282 15.7575 7.60177 15.6685C6.34062 15.0814 5.55236 13.2382 5.55236 11.7573C5.55236 8.57288 7.86582 5.64784 12.2233 5.64784C15.7257 5.64784 18.4472 8.14303 18.4472 11.4789C18.4472 14.9583 16.253 17.7583 13.2084 17.7583C12.1852 17.7583 11.2238 17.2268 10.8949 16.5989C10.8949 16.5989 10.3886 18.5264 10.2655 18.9989C10.053 19.8162 9.14357 21.5092 8.68701 22.2783C9.73144 22.6156 10.844 22.7999 11.9992 22.7999C17.9545 22.7999 22.7992 17.9553 22.7992 12C22.7992 6.04486 17.9545 1.19995 11.9992 1.19995Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest-icon.a2c6ec7473355e7ec686db79272f21d9.svg";
export { ForwardRef as ReactComponent };